import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import partial from 'lodash/partial';
import { reinstate } from 'project/ducks/creatives';
import Removed from 'project/components/removed';
import { getProjectIdFromUrl } from 'project/utils';

export function mapStateToProps(state) {
  const { removed } = state.project.creatives;

  return {
    removed,
  };
}

export function mapDispatchToProps(dispatch, { params }) {
  const projectId = getProjectIdFromUrl(params);
  return bindActionCreators({
    reinstate: partial(reinstate, projectId)
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Removed));



// WEBPACK FOOTER //
// ./project/containers/removed.js